import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import Utils from "../../common/manipurCommon/Utils";

const UserRoleMenuPermission = () => {

    const [rbacList, setRbacList] = useState<any[]>([]);
    const [rolesList, setRolesList] = useState<any[]>([]);
    const [permissionList, setPermissionList] = useState<any[]>([]);
    const [menuList, setMenuList] = useState<any[]>([]);
    const [submenuList, setSubmenuList] = useState<any[]>([]);
    const [accountTypeList, setAccountTypeList] = useState<any[]>([]);
    const [permissionValues, setPermissionValues] = useState({});
    const [accountTypeId, setAccountTypeId] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [roleId, setRoleId] = useState("");
    const [menuId, setMenuId] = useState("");
    const [rleMnuPmsn, setRleMnuPmsn] = useState("");
    const [rleMnuStatus, setRleMnuStatus] = useState("");
    const [subMenuId, setSubMenuId] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchUserRbac() {
            setIsLoading(true);
            const rbacResponse = await func.listUserRBAC();
            setRbacList(Array.isArray(rbacResponse) ? rbacResponse : [])
            setIsLoading(false);
        }
        fetchUserRbac();
    }, [])

    const filteredData = rbacList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const roleRender = (rowData) => {
        return <span>{rowData.roleName}</span>;
    };

    const menuRender = (rowData) => {
        return <span>{rowData.menuTitle}</span>;
    };

    const subMenuRender = (rowData) => {
        return <span>{rowData.submenuTitle}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.roleMenuPermissionStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editUserRBAC(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const rlemnupmsnId = rowData.roleMenuPermissionId;
        return (
            <Link to="#" onClick={() => deleteRBAC(rlemnupmsnId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newRBAC() {
        const rolesResponse = await func.listRoles();
        setRolesList(Array.isArray(rolesResponse) ? rolesResponse : [])
        const permissionResponse = await func.listPermission();
        setPermissionList(Array.isArray(permissionResponse) ? permissionResponse : [])
        const accResponse = await func.accountType(null);
        setAccountTypeList(Array.isArray(accResponse) ? accResponse : [])
        setIsEdit(false)
        setOpenModal(true)
        // setAccountTypeId("");
        setRoleId("")
        setMenuId("")
        setSubMenuId([])
        // setPermissionValues({})
        setPermissionValues(
            Object.fromEntries(permissionResponse.map(item => [
                item.permissionKeyName,
                "0"   // default unchecked
            ]))
        );
    }


    async function editUserRBAC(rowData: { roleMenuPermissionId: string | number; }) {
        const rbacId = rowData.roleMenuPermissionId;
        setIsEdit(true)
        setOpenModal(true)
        const rolesResponse = await func.listRoles();
        setRolesList(Array.isArray(rolesResponse) ? rolesResponse : [])
        const accResponse = await func.accountType(null);
        setAccountTypeList(Array.isArray(accResponse) ? accResponse : [])
        const mnuResponse = await func.listMenus();
        setMenuList(Array.isArray(mnuResponse) ? mnuResponse : [])
        const permissionResponse = await func.listPermission();
        setPermissionList(Array.isArray(permissionResponse) ? permissionResponse : [])
        const getDetails = await func.getUserRBAC(rbacId);
        setRleMnuPmsn(getDetails.roleMenuPermissionId);
        setRoleId(getDetails.roleId)
        setMenuId(getDetails.menuId)
        const sbmnuResponse = await func.getSubmenusByMenu(getDetails.menuId);
        setSubmenuList(Array.isArray(sbmnuResponse) ? sbmnuResponse : [])
        setRleMnuStatus(getDetails.roleMenuPermissionStatus)
        setSubMenuId(getDetails.subMenuId)
        // setAccountTypeId(getDetails.hasSubmenuAccess);
        setPermissionValues({
            view: getDetails.viewPermission || "0",
            edit: getDetails.editPermission || "0",
            add: getDetails.addPermission || "0",
            delete: getDetails.deletePermission || "0"
        })
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateRBAC();
            } else {
                if (roleId && menuId && subMenuId) {
                    const formData = new FormData();
                    formData.append("roleId", roleId);
                    formData.append("menuId", menuId);
                    formData.append("subMenuId", JSON.stringify(subMenuId.map(Number)));
                    formData.append("permissions", JSON.stringify(permissionValues));

                    const createRBAC = api.CreateUserRBAC;
                    fetch(createRBAC, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }
            }
        }
    }

    function updateRBAC() {
        const formData = new FormData();
        formData.append("roleId", roleId);
        formData.append("menuId", menuId);
        formData.append("subMenuId", JSON.stringify(subMenuId.map(Number)));
        formData.append("permissions", JSON.stringify(permissionValues));
        formData.append("status", rleMnuStatus);

        const updateRoleMnuPmsn = api.UpdateUserRBAC + '/' + rleMnuPmsn;
        fetch(updateRoleMnuPmsn, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteRBAC(rlemnupmsnId: string) {
        const deleteRole = api.DeleteRole + '/' + rlemnupmsnId;
        fetch(deleteRole, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>User RBAC</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newRBAC() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create User RBAC">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="roleName"
                                                header="Role Name"
                                                body={roleRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="menuTitle"
                                                header="Menu Name"
                                                body={menuRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="submenuTitle"
                                                header="Sub Menu Name"
                                                body={subMenuRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="roleMenuPermissionStatus"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} RBAC</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Role Name</label>
                                        <Select
                                            value={rolesList.find(role => role.roleId === roleId) ? {
                                                value: roleId,
                                                label: rolesList.find(role => role.roleId === roleId).roleName
                                            } : null}
                                            onChange={async (e) => {
                                                setRoleId(e.value);
                                                const mnuResponse = await func.listMenus();
                                                setMenuList(Array.isArray(mnuResponse) ? mnuResponse : [])
                                            }}
                                            isDisabled={isEdit}
                                            required
                                            placeholder="Select Role"
                                            options={rolesList.map(role => ({
                                                value: role.roleId,
                                                label: role.roleName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                { /*<div className="col-lg-12 mb-10">
                                    <label className="form-label">Account Access</label>
                                    <Select
                                        value={accountTypeList.find(acc => acc.accountTypeId === accountTypeId) ? {
                                            value: accountTypeId,
                                            label: accountTypeList.find(acc => acc.accountTypeId === accountTypeId)?.accountName
                                        } : null}
                                        onChange={async (e) => {
                                            setAccountTypeId(e.value);
                                            const mnuResponse = await func.listMenusByAccId(e.value);
                                            setMenuList(Array.isArray(mnuResponse) ? mnuResponse : [])
                                        }}
                                        required
                                        // styles={customSelect}
                                        placeholder="Select Account Type"
                                        options={accountTypeList.map(acc => ({
                                            value: acc.accountTypeId,
                                            label: acc.accountName
                                        }))}>
                                    </Select>
                                </div> */}
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Menu Name</label>
                                        <Select
                                            value={menuList.find(menu => menu.menuId === menuId) ? {
                                                value: menuId,
                                                label: menuList.find(menu => menu.menuId === menuId).menuTitle
                                            } : null}
                                            onChange={async (e) => {
                                                setMenuId(e.value);
                                                const mnuResponse = await func.getSubmenusByMenu(e.value);
                                                setSubmenuList(Array.isArray(mnuResponse) ? mnuResponse : [])
                                            }}
                                            isDisabled={isEdit}
                                            required
                                            placeholder="Select Menu"
                                            options={menuList.map(menu => ({
                                                value: menu.menuId,
                                                label: menu.menuTitle
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">SubMenu Name</label>
                                        <Select
                                            isMulti={!isEdit}
                                            value={Array.isArray(submenuList)
                                                ? submenuList
                                                    .filter(submenu => subMenuId.includes(submenu.submenuId))
                                                    .map(submenu => ({
                                                        value: submenu.submenuId,
                                                        label: submenu.submenuTitle
                                                    }))
                                                : []
                                            }
                                            onChange={(selectedOptions) => {
                                                // const selectedIds = selectedOptions.map(option => option.value);
                                                const selectedIds = Array.isArray(selectedOptions)
                                                    ? selectedOptions.map(option => option.value)
                                                    : selectedOptions
                                                        ? [selectedOptions.value]
                                                        : [];
                                                setSubMenuId(selectedIds);
                                            }}
                                            options={Array.isArray(submenuList)
                                                ? submenuList.map(submenu => ({
                                                    value: submenu.submenuId,
                                                    label: submenu.submenuTitle
                                                }))
                                                : []
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    {permissionList.map((item) => (
                                        <div className="col-auto" key={item.permissionId}>
                                            {/* <div className="form-check form-switch mb-2"> */}
                                            <div className="d-flex align-items-center form-check form-switch mb-2">
                                                <label
                                                    className="form-check-label ms-2"
                                                    htmlFor={`permission_${item.permissionId}`}
                                                >
                                                    {item.permissionName}
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`permission_${item.permissionId}`}
                                                    checked={permissionValues[item.permissionKeyName] === item.permissionId}
                                                    onChange={(e) => {
                                                        setPermissionValues((prev) => ({
                                                            ...prev,
                                                            [item.permissionKeyName]: e.target.checked ? item.permissionId : "0"
                                                        }));
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={rleMnuStatus === '1'}
                                                        id="permissionStatus"
                                                        onChange={(e) => {
                                                            setRleMnuPmsn(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default UserRoleMenuPermission;